import { ApiBase } from "@/api/ApiBase";
import { Formatter } from "@/utils/Formatter";
import type { TerminalPOS } from "@/api/session";

export interface CaixaDisponivel {
  id: number;
  nome: string;
  estabelecimento_id: number;
}

export interface EstabelecimentoComCaixaLivre {
  id: number;
  nome: string;
  numero: string;
}

export interface EssencialAberturaCaixa {
  caixas: CaixaDisponivel[];
  estabelecimentos: EstabelecimentoComCaixaLivre[];
}

export interface EssencialFechoCaixa {
  vendasTotais: number;
  vendasTotaisCash: number;
  saldoCaixa: number;
  saldoLevantadoCaixa: number;
}

export interface RetiradaHistorico {
  id: number;
  valor: number;
  descricao: string;
  dataCriacao: string;
}

export interface EssencialRetiradaCash {
  vendasTotaisCash: number;
  saldoCaixa: number;
  historicoRetiradas: RetiradaHistorico[];
}

export interface RespostaCaixaPos {
  msg: string;
  tipo: string;
}

export interface HistoricoCaixaItem {
  idSessao: number;
  dataAbertura: string;
  dataFecho: string | null;
  valorAbertura: number;
  valorFecho: number;
  estado: "Aberto" | "Fechado";
  nomeEstabelecimento: string;
  numeroEstabelecimento: string;
  nomeCaixa: string;
  totalVendas: number;
}

export class CaixaPosApi extends ApiBase {
  essencialToAberturaCaixa(): Promise<EssencialAberturaCaixa> {
    return this.http.put<EssencialAberturaCaixa>(
      "/api/facturacao/info-auxiliar/essencial-to-abertura-caixa-pos",
    );
  }

  essencialToFechoCaixa(): Promise<EssencialFechoCaixa> {
    return this.http.put<EssencialFechoCaixa>(
      "/api/facturacao/info-auxiliar/essencial-to-fecho-caixa-pos",
    );
  }

  essencialToRetiradaCash(): Promise<EssencialRetiradaCash> {
    return this.http.put<EssencialRetiradaCash>(
      "/api/facturacao/info-auxiliar/essencial-to-retirada-cash-pos",
    );
  }

  abrirCaixa(dados: {
    caixaId: number;
    terminal: TerminalPOS;
    valorAbertura: number;
    obs: string;
  }): Promise<RespostaCaixaPos> {
    return this.http.post<RespostaCaixaPos>("/api-pos/caixa/start", {
      "caixa.id": String(dados.caixaId),
      terminal: dados.terminal,
      valorTextoCaixa: Formatter.moeda(dados.valorAbertura),
      obs: dados.obs,
    });
  }

  fecharCaixa(dados: {
    valorContado: number;
    obs2: string;
  }): Promise<RespostaCaixaPos> {
    return this.http.post<RespostaCaixaPos>("/api-pos/caixa/finish", {
      valorTextoCaixa: Formatter.moeda(dados.valorContado),
      obs2: dados.obs2,
    });
  }

  retirarCashCaixa(dados: {
    motivo: string;
    valor: number;
  }): Promise<RespostaCaixaPos> {
    return this.http.post<RespostaCaixaPos>(
      "/api-pos/caixa/retirar-cash-caixa",
      {
        motivoRetirada: dados.motivo,
        valorTextoCaixa: Formatter.moeda(dados.valor),
      },
    );
  }

  listaHistoricoCaixas(pagina: number): Promise<HistoricoCaixaItem[]> {
    return this.http.put<HistoricoCaixaItem[]>(
      `/api-pos/caixa/lista-historico-caixa-by-comerciante-and-vendedor/${pagina}`,
    );
  }
}
